import { useContractRead } from "wagmi"
import { getAddress } from "./getAddress"
import PriceFeedContract from "@src/lib/artifacts/contracts/PriceFeed.sol/PriceFeed"
import { parseEther } from "viem"
import { constants } from "@src/constants"

export const quoteParams = (chainId: number) => [
  parseEther("1"),
  constants[chainId].addresses["ETHPriceFeed"],
  constants[chainId].addresses["USDCPriceFeed"],
  1800 // TWAP Interval
]

export const useEthUsd = (chainId: number) => {
  // return 1000

  const params = {
    address: getAddress(chainId, "PriceFeed") as `0x${string}`,
    abi: PriceFeedContract.abi,
    functionName: "getQuote",
    args: quoteParams(chainId),
    watch: true
  }
  // {
  //     address: chainlinkFeedAddress,
  //     abi: ChainlinkContract.abi,
  //     functionName: "latestRoundData",
  //     args: [],
  //     watch: true
  //   }

  const calldata = useContractRead(params)

  return calldata?.data && Number(calldata?.data) / 1e6
  // Chainlink: calldata?.data && Number(calldata?.data[1]) / 1e8
}
